import '../../themes/merchant-next/color/index.js';
import { TextStyleSemanticsAll } from '../../themes/merchant-next/textStyle/textStyle-semantics.js';
import '../../themes/merchant-next/borderWidth/index.js';
import '../../themes/merchant-next/shape/index.js';
import { BorderWidthSemanticsAll } from '../../themes/merchant-next/borderWidth/borderWidth-semantics.js';
import { ColorSemanticsAll } from '../../themes/merchant-next/color/color-semantics.js';
import { ShapeSemanticsAll } from '../../themes/merchant-next/shape/shape-semantics.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var MerchantNextOverrides = {
  BorderWidth: _objectSpread({}, BorderWidthSemanticsAll),
  Colors: _objectSpread({}, ColorSemanticsAll),
  Modal: {
    hasDynamicPadding: true
  },
  Shape: _objectSpread({}, ShapeSemanticsAll),
  Sidesheet: {
    shouldUseDynamicPadding: true,
    panelWidths: {
      Mobile: '100vw',
      Tablet: '375px',
      Desktop: '480px',
      WideScreen: '560px',
      UltraWideScreen: '560px'
    }
  },
  Typography: {
    TextStyles: _objectSpread({}, TextStyleSemanticsAll)
  }
};

export { MerchantNextOverrides };
